import { isDefined } from "@clipboard-health/util-ts";
import { useQuery } from "@tanstack/react-query";

import { getAddressByGeoCode } from "../googleMaps";
import { type Location } from "../types";

export function useGetAddressByGeoCode(location?: Location) {
  return useQuery({
    queryKey: ["addressByGeoCode", location],
    queryFn: async () => {
      return location ? await getAddressByGeoCode(location) : undefined;
    },
    // Addresses rarely change, so we cache them indefinitely to prevent unnecessary refetches
    // and reduce re-renders across components using this data
    staleTime: Number.POSITIVE_INFINITY,
    enabled: isDefined(location),
  });
}
